import { render, staticRenderFns } from "./CrmPloyInfo.vue?vue&type=template&id=794d4c9e"
import script from "./CrmPloyInfo.vue?vue&type=script&lang=js"
export * from "./CrmPloyInfo.vue?vue&type=script&lang=js"
import style0 from "./CrmPloyInfo.vue?vue&type=style&index=0&id=794d4c9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports